<template>
    <div class="electric-meter-container">
        <!-- 查询条件 -->
        <el-card>
            <div slot="header" class="clearfix flex justify-between">
                <span>{{ $t('electricMeter.search.title') }}</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input v-model="queryInfo.meterNo" :placeholder="$t('electricMeter.search.meterNo')" clearable/>
                </el-col>
                <el-col :span="4">
                    <el-input v-model="queryInfo.remark" :placeholder="$t('electricMeter.search.remark')" clearable/>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="queryInfo.meterType" :placeholder="$t('electricMeter.search.meterType')"
                               clearable>
                        <el-option label="全部" value=""/>
                        <el-option label="总表" value="1001"/>
                        <el-option label="分表" value="1002"/>
                        <el-option label="独立表" value="1003"/>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="queryInfo.phaseType" :placeholder="$t('electricMeter.search.phaseType')"
                               clearable>
                        <el-option label="全部" value=""/>
                        <el-option label="单相" value="2001"/>
                        <el-option label="三相" value="2002"/>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="queryInfo.state" :placeholder="$t('electricMeter.search.state')" clearable>
                        <el-option label="全部" value=""/>
                        <el-option label="启用" value="1100"/>
                        <el-option label="停用" value="1101"/>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="_queryMethod">
                        {{ $t('common.search') }}
                    </el-button>
                    <el-button @click="_resetQuery">重置</el-button>
                </el-col>
            </el-row>
        </el-card>

        <!-- 电表列表 -->
        <el-card>
            <div slot="header" class="clearfix flex justify-between">
                <span>{{ $t('electricMeter.list.title') }}</span>
                <div style="float: right;">
                    <el-button type="warning" size="small" @click="_openBalanceLogDialog">
                        余额变更记录
                    </el-button>
                    <el-button type="primary" size="small" @click="_openAddModal">
                        {{ $t('electricMeter.list.addElectricMeter') }}
                    </el-button>
                </div>
            </div>
            <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                <el-table-column prop="meterNo" :label="$t('electricMeter.table.meterNo')" align="center" width="130"/>
                <el-table-column prop="roomNum" :label="$t('electricMeter.table.roomNum')" align="center" width="90">
                    <template #default="{ row }">
                        {{ row.roomNum }}
                    </template>
                </el-table-column>
                <el-table-column prop="roomRemark" :label="$t('electricMeter.table.remark')" width="250" align="center"
                                 show-overflow-tooltip/>
                <el-table-column prop="rechargeLimit" :label="'周期充值上限'" align="center" width="110">
                    <template #default="{ row }">
                        {{ row.rechargeLimit ? '¥' + row.rechargeLimit : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="balanceReminder" :label="'余额提醒下限'" align="center" width="110">
                    <template #default="{ row }">
                        {{ row.balanceReminder ? '¥' + row.balanceReminder : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="balance" :label="'余额'" align="center" width="100">
                    <template #default="{ row }">
                        <span :style="{ color: row.balance < (row.balanceReminder || 0) ? '#f56c6c' : '' }">
                          {{ row.balance !== undefined && row.balance !== null ? '¥' + row.balance : '-' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="stateName" :label="$t('electricMeter.table.state')" align="center" width="70">
                    <template #default="{ row }">
                        <el-tag v-if="row.state === '1100'" type="success" size="small">启用</el-tag>
                        <el-tag v-else type="info" size="small">停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" :label="$t('electricMeter.table.createTime')" align="center"
                                 width="160"/>
                <el-table-column prop="meterTypeName" :label="$t('electricMeter.table.meterType')" align="center"
                                 width="80">
                    <template #default="{ row }">
                        <el-tag v-if="row.meterType === '1001'" type="danger" size="small">总表</el-tag>
                        <el-tag v-else-if="row.meterType === '1002'" type="warning" size="small">分表</el-tag>
                        <el-tag v-else-if="row.meterType === '1003'" type="success" size="small">独立表</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="phaseTypeName" :label="$t('electricMeter.table.phaseType')" align="center"
                                 width="80">
                    <template #default="{ row }">
                        <span v-if="row.phaseType === '2001'">单相</span>
                        <span v-else-if="row.phaseType === '2002'">三相</span>
                    </template>
                </el-table-column>
                <el-table-column prop="parentMeterId" :label="$t('electricMeter.table.parentMeterNo')" align="center"
                                 width="80">
                    <template #default="{ row }">
                        {{ row.parentMeterId || '-' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('electricMeter.table.operation')" align="center" width="180" fixed="right">
                    <template #default="{ row }">
                        <el-tooltip content="编辑" placement="top">
                            <el-button size="mini" type="primary" icon="el-icon-edit" circle
                                       @click="_openEditModal(row)"/>
                        </el-tooltip>
                        <el-tooltip content="改电表" placement="top">
                            <el-button size="mini" type="warning" icon="el-icon-switch-button" circle
                                       @click="_openChangeMeterNoModal(row)"/>
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                            <el-button size="mini" type="danger" icon="el-icon-delete" circle
                                       @click="_openDeleteModal(row)"/>
                        </el-tooltip>
                        <el-tooltip content="查看状态" placement="top">
                            <el-button size="mini" type="success" icon="el-icon-view" circle
                                       @click="_openStatusModal(row)"/>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="pagination.current"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pagination.size"
                :total="pagination.total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </el-card>

        <!-- 添加/编辑对话框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="600px"
            @close="_resetForm"
        >
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item :label="$t('electricMeter.form.meterNo')" prop="meterNo">
                    <el-input v-model="form.meterNo" :placeholder="$t('electricMeter.form.pleaseInput')"
                              :disabled="isEdit"/>
                </el-form-item>
                <el-form-item :label="$t('electricMeter.form.meterType')" prop="meterType">
                    <el-select v-model="form.meterType" :placeholder="$t('electricMeter.form.pleaseSelect')"
                               style="width: 100%">
                        <el-option label="总表" value="1001"/>
                        <el-option label="分表" value="1002"/>
                        <el-option label="独立表" value="1003"/>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('electricMeter.form.phaseType')" prop="phaseType">
                    <el-select v-model="form.phaseType" :placeholder="$t('electricMeter.form.pleaseSelect')"
                               style="width: 100%">
                        <el-option label="单相" value="2001"/>
                        <el-option label="三相" value="2002"/>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('electricMeter.form.roomNum')" prop="roomNum">
                    <el-input v-model="form.roomNameDisplay" :placeholder="$t('electricMeter.form.pleaseSelect')"
                              disabled style="width: 70%">
                        <template slot="append">
                            <el-button icon="el-icon-search" @click="_openSearchRoom"></el-button>
                        </template>
                    </el-input>
                    <el-button v-if="form.roomNum" type="text" icon="el-icon-close" style="margin-left: 5px"
                               @click="_clearRoom">清除
                    </el-button>
                </el-form-item>
                <el-form-item v-if="form.meterType === '1002'" :label="$t('electricMeter.form.parentMeterId')"
                              prop="parentMeterId">
                    <el-input v-model="form.parentMeterId" :placeholder="$t('electricMeter.form.pleaseInput')"/>
                </el-form-item>
                <el-form-item :label="$t('electricMeter.form.remark')" prop="remark" v-show="false">
                    <el-input v-model="form.remark" type="textarea" :rows="3"
                              :placeholder="$t('electricMeter.form.pleaseInput')"/>
                </el-form-item>
                <el-form-item label="周期充值上限" prop="rechargeLimit">
                    <el-input-number v-model="form.rechargeLimit" :min="0" :precision="2" :step="100"
                                     placeholder="请输入周期充值上限" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="余额提醒下限" prop="balanceReminder">
                    <el-input-number v-model="form.balanceReminder" :min="0" :precision="2" :step="10"
                                     placeholder="请输入余额提醒下限" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="余额" prop="balance">
                    <el-input-number
                        v-model="form.balance"
                        :precision="2"
                        :step="100"
                        :disabled="!hasPrivilege('502026070132370029')"
                        placeholder="请输入余额"
                        style="width: 100%"
                    />
                    <span v-if="!hasPrivilege('502026070132370029')"
                          style="color: #909399; font-size: 12px; margin-left: 10px;">（您没有权限编辑此项）</span>
                </el-form-item>
                <el-form-item v-if="!isEdit" label="此余额时电表数" prop="startMeter">
                    <el-input-number v-model="form.startMeter" :min="0" :precision="2" :step="1"
                                     placeholder="请输入此余额时电表数" style="width: 100%"/>
                </el-form-item>
                <el-form-item :label="$t('electricMeter.form.state')" prop="state">
                    <el-radio-group v-model="form.state">
                        <el-radio label="1100">启用</el-radio>
                        <el-radio label="1101">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" :loading="submitLoading" @click="_submitForm">{{
                        $t('common.confirm')
                    }}
                </el-button>
            </div>
        </el-dialog>
        <!-- 选择房屋弹窗 -->
        <search-room ref="searchRoom" @chooseRoom="_handleChooseRoom"/>

        <!-- 余额变更记录弹窗 -->
        <el-dialog
            title="余额变更记录"
            :visible.sync="balanceLogDialogVisible"
            width="1000px"
            @close="_resetBalanceLog"
        >
            <!-- 添加查询条件区域 -->
            <el-card style="margin-bottom: 15px;">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-input v-model="balanceLogQuery.meterNo" :placeholder="$t('electricMeter.search.meterNo')"
                                  clearable/>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="balanceLogQuery.roomNum" :placeholder="$t('electricMeter.table.roomNum')"
                                  clearable/>
                    </el-col>
                    <el-col :span="6">
                        <el-input v-model="balanceLogQuery.roomRemark"
                                  :placeholder="`${$t('electricMeter.search.remark')}(商铺名)`" clearable/>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="primary" @click="_queryBalanceLog">
                            {{ $t('common.search') }}
                        </el-button>
                        <el-button @click="_resetBalanceLogQuery">重置</el-button>
                    </el-col>
                </el-row>
            </el-card>
            <el-table :data="balanceLogData" border style="width: 100%" v-loading="balanceLogLoading">
                <el-table-column prop="meterNo" label="电表编号" align="center"/>
                <el-table-column prop="roomNum" label="商铺编号" align="center"/>
                <el-table-column prop="roomRemark" label="商铺名称" align="center"/>
                <el-table-column prop="oldBalance" label="变更前余额" align="center">
                    <template #default="{ row }">
                        {{ row.oldBalance !== undefined && row.oldBalance !== null ? '¥' + row.oldBalance : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="newBalance" label="变更后余额" align="center">
                    <template #default="{ row }">
                        {{ row.newBalance !== undefined && row.newBalance !== null ? '¥' + row.newBalance : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="变更时间" align="center" width="160"/>
                <el-table-column prop="userName" label="操作人" align="center"/>
            </el-table>
            <el-pagination
                :current-page.sync="balanceLogPagination.current"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="balanceLogPagination.size"
                :total="balanceLogPagination.total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="_balanceLogSizeChange"
                @current-change="_balanceLogPageChange"
            />
            <div slot="footer" class="dialog-footer">
                <el-button @click="balanceLogDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 电表状态弹窗 -->
        <el-dialog
            title="电表状态信息"
            :visible.sync="statusDialogVisible"
            width="500px"
        >
            <div v-loading="statusLoading">
                <el-descriptions :column="1" border>
                    <el-descriptions-item label="电表编号">{{ statusData.meterNo }}</el-descriptions-item>
                    <el-descriptions-item label="阀控状态">
                        <el-tag :type="statusData.switch ? 'success' : 'info'" size="small">
                            {{ statusData.switch ? '合闸' : '断闸' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="保护状态">
                        <el-tag :type="statusData.guard ? 'warning' : 'success'" size="small">
                            {{ statusData.guard ? '已保电' : '未保电' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="倍率">{{ statusData.multiple }}</el-descriptions-item>
                    <el-descriptions-item label="总电量">{{ statusData.total }}</el-descriptions-item>
                    <el-descriptions-item label="最后通讯时间">{{ statusData.lastDate || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="是否可开启">
                        <el-tag :type="statusData.canOpen ? 'success' : 'info'" size="small">
                            {{ statusData.canOpen ? '是' : '否' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="是否启用">
                        <el-tag :type="statusData.enable ? 'success' : 'info'" size="small">
                            {{ statusData.enable ? '是' : '否' }}
                        </el-tag>
                    </el-descriptions-item>
                </el-descriptions>

                <div style="margin-top: 20px; text-align: center;">
                    <el-button
                        type="danger"
                        :loading="switchLoading"
                        @click="_openBreakSwitchConfirm"
                    >
                        断闸
                    </el-button>
                    <el-button
                        type="success"
                        :loading="switchLoading"
                        style="margin-left: 10px;"
                        @click="_openCloseSwitchConfirm"
                    >
                        合闸
                    </el-button>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="statusDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 更改电表号弹窗 -->
        <el-dialog
            title="更改电表号"
            :visible.sync="changeMeterNoDialogVisible"
            width="500px"
            @close="_resetChangeMeterNoForm"
        >
            <el-form ref="changeMeterNoForm" :model="changeMeterNoForm" label-width="120px">
                <el-form-item label="当前电表号">
                <el-input :value="changeMeterNoForm.oldMeterNo" disabled/>
            </el-form-item>
            <el-form-item label="新电表号" prop="meterNo">
                <div style="display: flex;">
                    <el-input v-model="changeMeterNoForm.meterNo" placeholder="请输入新电表号"/>
                    <el-button type="primary" style="margin-left: 10px;" @click="_queryMeterReading">
                        查询表读数
                    </el-button>
                </div>
            </el-form-item>
                <el-form-item label="当前电表读数" prop="startMeter">
                    <el-input v-model="changeMeterNoForm.startMeter" placeholder="请输入当前电表读数"/>
                </el-form-item>
                <el-form-item label="最后通讯时间">
                    <el-input :value="changeMeterNoForm.lastDate" disabled placeholder="点击查询表读数获取"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeMeterNoDialogVisible = false">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" :loading="changeMeterNoLoading" @click="_submitChangeMeterNo">
                    {{ $t('common.confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    listElectricMeters,
    saveElectricMeter,
    updateElectricMeter,
    deleteElectricMeter,
    getElectricMeterStatus,
    controlElectricMeterSwitch,
    listElectricMeterBalanceChanges,
    changeElectricMeterNo
} from '@/api/community/electricMeterApi'
import {getCommunityId} from '@/api/community/communityApi'
import {getUserId, getUserName} from '@/api/user/userApi'
import {queryRooms} from '@/api/room/roomApi'
import SearchRoom from '@/components/room/searchRoom'

export default {
    name: 'ElectricMeterManage',
    components: {
        SearchRoom
    },
    data() {
        return {
            loading: false,
            submitLoading: false,
            roomMap: {}, // 房屋编号 -> 房屋信息的映射
            queryInfo: {
                meterNo: '',
                remark: '',
                meterType: '',
                phaseType: '',
                state: ''
            },
            tableData: [],
            pagination: {
                current: 1,
                size: 10,
                total: 0
            },
            dialogVisible: false,
            dialogTitle: '添加电表',
            isEdit: false,
            form: {
                meterId: '',
                meterNo: '',
                meterType: '',
                phaseType: '',
                roomNum: '',
                roomId: '',
                roomNameDisplay: '',
                floorNum: '',
                unitNum: '',
                parentMeterId: '0',
                remark: '',
                rechargeLimit: null,
                balanceReminder: null,
                balance: 0,
                startMeter: null,
                state: '1100'
            },
            rules: {
                meterNo: [{required: true, message: '请输入电表号', trigger: 'blur'}],
                meterType: [{required: true, message: '请选择电表类型', trigger: 'change'}],
                phaseType: [{required: true, message: '请选择相线类型', trigger: 'change'}]
            },
            statusDialogVisible: false,
            statusLoading: false,
            switchLoading: false,
            statusData: {
                meterNo: '',
                switch: false,
                guard: false,
                multiple: 1,
                total: 0,
                lastDate: '',
                canOpen: false,
                enable: false
            },
            balanceLogDialogVisible: false,
            balanceLogLoading: false,
            balanceLogData: [],
            balanceLogPagination: {
                current: 1,
                size: 10,
                total: 0
            },
            balanceLogQuery: {
                roomRemark: '',
                meterNo: '',
                roomNum: ''
            },
            changeMeterNoDialogVisible: false,
            changeMeterNoLoading: false,
            changeMeterNoForm: {
                meterId: '',
                oldMeterNo: '',
                meterNo: '',
                startMeter: '',
                lastDate: ''
            },
        }
    },
    created() {
        this._loadData()
    },
    methods: {
        // 加载数据
        _loadData() {
            this.loading = true
            const params = {
                ...this.queryInfo,
                page: this.pagination.current,
                row: this.pagination.size,
                communityId: getCommunityId()
            }
            listElectricMeters(params).then(res => {
                // 兼容不同的返回数据结构
                const dataList = res.data || []
                const total = res.total !== undefined ? res.total : (res.count || 0)

                this.tableData = Array.isArray(dataList) ? dataList : []
                this.pagination.total = total
                this.loading = false
                // 加载房屋信息映射
                this._loadRoomMap()
            }).catch(error => {
                console.error('请求失败', error)
                this.loading = false
            })
        },
        // 加载房屋信息映射（通过房屋编号查房屋信息）
        _loadRoomMap() {
            const roomNums = this.tableData
                .map(row => row.roomNum)
                .filter(num => num && !this.roomMap[num])
            if (roomNums.length === 0) return
            queryRooms({
                communityId: getCommunityId(),
                page: 1,
                row: 500
            }).then(res => {
                const rooms = res.rooms || []
                rooms.forEach(room => {
                    const key = room.roomNum
                    this.roomMap[key] = room
                })
            }).catch(error => {
                console.error('加载房屋信息失败', error)
            })
        },
        // 根据房屋编号获取房屋信息显示
        getRoomInfo(roomNum) {
            if (!roomNum) return '-'
            const room = this.roomMap[roomNum]
            if (room) {
                return room.floorNum + '-' + room.unitNum + '-' + room.roomNum + ''
            }
            return roomNum
        },
        // 查询
        _queryMethod() {
            this.pagination.current = 1
            this._loadData()
        },
        // 重置查询
        _resetQuery() {
            this.queryInfo = {
                remark: '',
                meterType: '',
                phaseType: '',
                state: ''
            }
            this._queryMethod()
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.size = val
            this._loadData()
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.current = val
            this._loadData()
        },
        // 打开添加对话框
        _openAddModal() {
            this.dialogTitle = '添加电表'
            this.isEdit = false
            this.dialogVisible = true
        },
        // 打开编辑对话框
        _openEditModal(row) {
            this.dialogTitle = '编辑电表'
            this.isEdit = true
            this.form = {
                meterId: row.meterId,
                meterNo: row.meterNo,
                meterType: row.meterType,
                phaseType: row.phaseType,
                roomNum: row.roomNum || '',
                roomId: row.roomId || '',
                roomNameDisplay: this.getRoomInfo(row.roomNum),
                floorNum: row.floorNum || '',
                unitNum: row.unitNum || '',
                parentMeterId: row.parentMeterId || '0',
                remark: row.remark || '',
                rechargeLimit: row.rechargeLimit || null,
                balanceReminder: row.balanceReminder || null,
                balance: row.balance || 0,
                state: row.state
            }
            this.dialogVisible = true
        },
        // 打开选择房屋弹窗
        _openSearchRoom() {
            this.$refs.searchRoom.open()
        },
        // 选择房屋回调
        _handleChooseRoom(room) {
            this.form.roomNum = room.roomNum
            this.form.roomId = room.roomId
            this.form.floorNum = room.floorNum
            this.form.unitNum = room.unitNum
            this.form.roomNameDisplay = room.floorNum + '-' + room.unitNum + '-' + room.roomNum + ''
        },
        // 清除已选房屋
        _clearRoom() {
            this.form.roomNum = ''
            this.form.roomId = ''
            this.form.floorNum = ''
            this.form.unitNum = ''
            this.form.roomNameDisplay = ''
        },
        // 打开删除对话框
        _openDeleteModal(row) {
            this.$confirm('确认删除该电表吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this._deleteMeter(row.meterId)
            }).catch(() => {
            })
        },
        // 删除电表
        _deleteMeter(meterId) {
            const params = {
                meterId: meterId,
                communityId: getCommunityId()
            }
            deleteElectricMeter(params).then(() => {
                this.$message.success('删除成功')
                this._loadData()
            }).catch(error => {
                this.$message.error('删除失败: ' + error.message)
            })
        },
        // 提交表单
        _submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitLoading = true
                    const params = {
                        ...this.form,
                        communityId: getCommunityId()
                    }

                    const apiCall = this.isEdit ? updateElectricMeter(params, getUserId(), getUserName()) : saveElectricMeter(params)

                    apiCall.then(() => {
                        this.$message.success(this.isEdit ? '更新成功' : '保存成功')
                        this.dialogVisible = false
                        this._loadData()
                        this.submitLoading = false
                    }).catch(error => {
                        this.$message.error((this.isEdit ? '更新失败: ' : '保存失败: ') + error.message)
                        this.submitLoading = false
                    })
                }
            })
        },
        // 重置表单
        _resetForm() {
            this.form = {
                meterId: '',
                meterNo: '',
                meterType: '',
                phaseType: '',
                roomNum: '',
                roomId: '',
                roomNameDisplay: '',
                floorNum: '',
                unitNum: '',
                parentMeterId: '0',
                remark: '',
                rechargeLimit: null,
                balanceReminder: null,
                balance: 0,
                startMeter: null,
                state: '1100'
            }
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },
        // 打开状态弹窗
        _openStatusModal(row) {
            this.statusDialogVisible = true
            this._loadMeterStatus(row.meterNo)
        },
        // 加载电表状态
        _loadMeterStatus(meterNo) {
            this.statusLoading = true
            getElectricMeterStatus(meterNo).then(res => {
                const data = res.data || {}
                this.statusData = {
                    meterNo: data.no || '',
                    switch: data.switch || false,
                    guard: data.guard || false,
                    multiple: data.multiple || 1,
                    total: data.total || 0,
                    lastDate: data.lastDate ? new Date(data.lastDate * 1000).toLocaleString() : '',
                    canOpen: data.canOpen || false,
                    enable: data.enable || false
                }
                this.statusLoading = false
            }).catch(error => {
                this.$message.error('获取电表状态失败: ' + error.message)
                this.statusLoading = false
            })
        },
        // 打开断闸确认弹窗
        _openBreakSwitchConfirm() {
            this.$confirm('确认要断闸该电表吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this._executeSwitch('close', '断闸')
            }).catch(() => {
            })
        },
        // 打开合闸确认弹窗
        _openCloseSwitchConfirm() {
            this.$confirm('确认要合闸该电表吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this._executeSwitch('open', '合闸')
            }).catch(() => {
            })
        },
        // 执行开关操作
        _executeSwitch(switchType, action) {
            this.switchLoading = true
            controlElectricMeterSwitch({
                deviceNo: this.statusData.meterNo,
                switchType: switchType
            }).then(() => {
                this.$message.success(`${action}成功`)
                // 刷新状态
                this._loadMeterStatus(this.statusData.meterNo)
                // 刷新列表数据
                this._loadData()
                this.switchLoading = false
            }).catch(error => {
                this.$message.error(`${action}失败: ` + error.message)
                this.switchLoading = false
            })
        },
        // 打开余额变更记录弹窗
        _openBalanceLogDialog() {
            this.balanceLogDialogVisible = true
            this._loadBalanceLog()
        },
        // 加载余额变更记录
        _loadBalanceLog() {
            this.balanceLogLoading = true
            const params = {
                ...this.balanceLogQuery, // 添加查询条件
                // 修改分页参数名称以匹配API要求
                page: this.balanceLogPagination.current,
                row: this.balanceLogPagination.size,
                communityId: getCommunityId()
            }
            listElectricMeterBalanceChanges(params).then(res => {
                this.balanceLogData = res.data || []
                this.balanceLogPagination.total = res.total || 0
                this.balanceLogLoading = false
            }).catch(error => {
                this.$message.error('获取电表余额变更记录失败: ' + error.message)
                this.balanceLogLoading = false
            })
        },
        // 查询余额变更记录
        _queryBalanceLog() {
            this.balanceLogPagination.current = 1
            this._loadBalanceLog()
        },
        // 重置余额变更记录查询条件
        _resetBalanceLogQuery() {
            this.balanceLogQuery = {
                roomRemark: '',
                meterNo: '',
                roomNum: ''
            }
            this._queryBalanceLog()
        },
        // 重置余额变更记录
        _resetBalanceLog() {
            this.balanceLogData = []
            this.balanceLogPagination = {
                current: 1,
                size: 10,
                total: 0
            }
            this.balanceLogQuery = {  // 重置查询条件
                roomRemark: '',
                meterNo: '',
                roomNum: ''
            }
        },


        // 余额变更记录分页大小改变
        _balanceLogSizeChange(val) {
            this.balanceLogPagination.size = val
            this._loadBalanceLog()
        },
        // 余额变更记录页码改变
        _balanceLogPageChange(val) {
            this.balanceLogPagination.current = val
            this._loadBalanceLog()
        },
        // 打开更改电表号弹窗
        _openChangeMeterNoModal(row) {
            this.changeMeterNoForm = {
                meterId: row.meterId,
                oldMeterNo: row.meterNo,
                meterNo: '',
                startMeter: '',
                lastDate: ''
            }
            this.changeMeterNoDialogVisible = true
        },
        // 查询表读数（复用查看状态的接口，按新电表号查询）
        _queryMeterReading() {
            const meterNo = this.changeMeterNoForm.meterNo
            if (!meterNo) {
                this.$message.warning('请先输入新电表号')
                return
            }
            getElectricMeterStatus(meterNo).then(res => {
                const data = res.data || {}
                this.changeMeterNoForm.lastDate = data.lastDate ? new Date(data.lastDate * 1000).toLocaleString() : ''
                this.changeMeterNoForm.startMeter = data.total || 0
                this.$message.success('查询表读数成功')
            }).catch(error => {
                this.$message.error('查询表读数失败: ' + error.message)
            })
        },
        // 提交更改电表号
        _submitChangeMeterNo() {
            const form = this.changeMeterNoForm
            if (!form.meterNo) {
                this.$message.warning('请输入新电表号')
                return
            }
            this.changeMeterNoLoading = true
            const params = {
                meterId: form.meterId,
                meterNo: form.meterNo,
                startMeter: form.startMeter
            }
            changeElectricMeterNo(params).then(() => {
                this.$message.success('更改电表号成功')
                this.changeMeterNoDialogVisible = false
                this.changeMeterNoLoading = false
                this._loadData()
            }).catch(error => {
                this.$message.error('更改电表号失败: ' + error.message)
                this.changeMeterNoLoading = false
            })
        },
        // 重置更改电表号表单
        _resetChangeMeterNoForm() {
            this.changeMeterNoForm = {
                meterId: '',
                oldMeterNo: '',
                meterNo: '',
                startMeter: '',
                lastDate: ''
            }
        }
    }
}
</script>

<style scoped>
.electric-meter-container {
    padding: 20px;
}
</style>